import React, { useEffect, useRef, useState } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Row, Col, Button } from 'react-bootstrap';
import Contacto from './Contacto';
import '../styles/Inicio.css';
import { ScrollToTop } from './ScrollToTop';
import ScrollReveal from "scrollreveal";

import introVideo from '../assets/videos/Intro.mp4';
import CarouselComponent from './Carousel';
// imagenes de servicios
import logoGif from '../assets/images/logo.gif';
import camarerosImg from '../assets/images/Inicio/servicios/camareros.jpg';
import cateringImg from '../assets/images/Inicio/servicios/catering.jpg';
import decoracionImg from '../assets/images/Inicio/servicios/decoracion.jpg';
import djImg from '../assets/images/Inicio/servicios/dj.jpg';
import materialImg from '../assets/images/Inicio/servicios/material.jpg';
import limpiezaImg from '../assets/images/Inicio/servicios/limpieza.jpg';
import entretenimientoImg from '../assets/images/Inicio/servicios/entretenimiento.jpg';

const Inicio = () => {
    const videoRef = useRef(null);

    const carouselRef = useRef(null);

    const [isMuted, setIsMuted] = useState(true); // Estado para manejar el mute/desmuteo

    const sr = ScrollReveal({
        origin: "top",
        distance: "60px",
        duration: 1500,
        delay: 0,
        reset: false,
    });

    const toggleMute = () => {
        const video = videoRef.current;
        if (video) {
            setIsMuted(!isMuted); // Cambia el estado
        }
    };

    // Scroll automático
    useEffect(() => {
        const scrollInterval = setInterval(() => {
            if (carouselRef.current) {
                const maxScrollLeft = carouselRef.current.scrollWidth - carouselRef.current.clientWidth;
                if (carouselRef.current.scrollLeft >= maxScrollLeft) {
                    carouselRef.current.scrollTo({ left: 0, behavior: 'smooth' });
                } else {
                    carouselRef.current.scrollBy({ left: 200, behavior: 'smooth' });
                }
            }
        }, 3000); // Cambiar imagen cada 3 segundos

        return () => clearInterval(scrollInterval);
    }, []);

    useEffect(() => {
        const handleScroll = () => {
            const scrollY = window.scrollY;
            const video = videoRef.current;
            if (video) {
                video.style.filter = `blur(${Math.min(scrollY / 100, 5)}px)`; // Aplica el blur según el scroll
            }
        };

        window.addEventListener('scroll', handleScroll);

        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);

    /* Animacion de revelado */
    useEffect(() => {
        sr.reveal(
            `.bienvenida-section h1, .bienvenida-section p, .services-section h1, .contacto-section, .collage`
        );
        sr.reveal(`.filaCentro`, { origin: "left" });
        sr.reveal(`.justify-content-center`, { origin: "right" });

    }, [sr]);

    // Reproduccion del video
    useEffect(() => {
        const video = videoRef.current;

        if (video) {
            video.muted = isMuted; // Silenciar el video inicialmente
            const playVideo = () => {
                video.play().catch((err) => {
                    console.error('Error al reproducir el video:', err);
                });
            };

            // Reproduce el video al cargar los datos
            video.addEventListener('loadeddata', playVideo);

            return () => {
                video.removeEventListener('loadeddata', playVideo);
            };
        }
    }, [isMuted]);

    // Función para hacer scroll al siguiente apartado
    const handleScrollToSection = (sectionId) => {
        const section = document.getElementById(sectionId);
        if (section) {
            section.scrollIntoView({ behavior: 'smooth' });
        }
    };

    return (
        <div>
            {/* Sección de Bienvenida con Video */}
            <section id="inicio-section" className="video-section full-screen">
                <video
                    ref={videoRef}
                    className="video-background"
                    autoPlay
                    loop
                    playsInline
                >
                    <source src={introVideo} type="video/mp4" />
                    Tu navegador no soporta la reproducción de video.
                </video>

                {/* Título centrado sobre el video */}
                <div className="video-title">
                    <h1 className="tituloInicio">¿Tienes un evento?<br />Nosotros nos encargamos</h1>
                </div>

                <button className="mute-button" onClick={toggleMute}>
                    {isMuted ? '🔇 Activar Sonido' : '🔊 Silenciar'}
                </button>
            </section>

            <div className="main-content">

                {/* Sección de Logo y Texto de bienvenida */}
                <section className="bienvenida-section">

                    <div className="logo-container">
                        <img src={logoGif} alt="Logo Alayi Events" className="logo" />
                    </div>

                    <div className='tituloG'>¿Tienes un evento?<br />Nosotros nos encargamos</div>

                    <p>
                        Toda celebración genera en la memoria recuerdos y emociones únicas, ya sea <strong>una cena romántica, una pedida de mano, un cumpleaños, un baby shower, una boda...</strong> Y es, en ese preciso momento, cuando nace Alayi Events, una empresa creada por la abogada ejerciente Sandra John Michael y que se dedica a la <strong>creación y organización integral de eventos, fiestas y bodas, independientemente de tu presupuesto.</strong>
                    </p>
                    <Button variant="primary" className="btn-scroll" onClick={() => handleScrollToSection('services-section')}>
                        Ver más
                        <span className="arrow"></span>
                    </Button>

                </section>

                {/* Sección de Servicios */}
                <section id="services-section" className="services-section">
                    <div className="tituloP-container">
                        <h1 className="tituloP">Nuestros servicios</h1>
                    </div>
                    <div className='services-icons'>
                        <Row className="justify-content-center">
                            <Col md={4} className="text-center service-item">
                                <img src={camarerosImg} alt="Servicio de camareros" className="service-image" />
                                <h3>Servicio de camareros</h3>
                                <p>Contamos con un equipo profesional de camareros para que nada le falte a tus invitados.</p>
                            </Col>
                            <Col md={4} className="text-center service-item">
                                <img src={cateringImg} alt="Servicio de catering" className="service-image" />
                                <h3>Servicio de catering</h3>
                                <p>Tenemos todo tipo de menús para tu banquete o cóctel de bienvenida.</p>
                            </Col>
                        </Row>

                        <Row className="filaCentro">
                            <Col md={4} className="text-center service-item">
                                <img src={decoracionImg} alt="Servicio de decoración" className="service-image" />
                                <h3>Servicio de decoración</h3>
                                <p>Transformamos cualquier espacio en un lugar de ensueño.</p>
                            </Col>
                            <Col md={4} className="text-center service-item">
                                <img src={djImg} alt="Servicio de DJ y sonido" className="service-image" />
                                <h3>Servicio de DJ y sonido</h3>
                                <p>Ponemos sonido y la música para animar tu evento.</p>
                            </Col>
                            <Col md={4} className="text-center service-item">
                                <img src={materialImg} alt="Servicio de material y mobiliario" className="service-image" />
                                <h3>Servicio de material y mobiliario</h3>
                                <p>Mesas, sillas, cubertería… Tenemos todo lo que necesitas.</p>
                            </Col>
                        </Row>

                        <Row className="justify-content-center">
                            <Col md={4} className="text-center service-item">
                                <img src={limpiezaImg} alt="Servicio de limpieza" className="service-image" />
                                <h3>Servicio de limpieza</h3>
                                <p>Mantén tu evento impecable con nuestro servicio de limpieza.</p>
                            </Col>
                            <Col md={4} className="text-center service-item">
                                <img src={entretenimientoImg} alt="Servicio de entretenimiento" className="service-image" />
                                <h3>Servicio de entretenimiento</h3>
                                <p>Desde animadores, artista o shows en vivo, tenemos todo para entretener a tus invitados.</p>
                            </Col>
                        </Row>
                        <div className="mt-4">
                            <h2>¿Creamos juntos el evento de tus sueños?</h2>
                            {/* <Button className="btn-scroll" as={Link} to="/edicion1">Nuestros eventos</Button> */}
                            <Button className="btn-scroll" onClick={() => handleScrollToSection('contacto-section')}>Contáctanos</Button>
                            <Button className="btn-scroll" onClick={() => handleScrollToSection('nuestros-eventos-section')}>Nuestros eventos</Button>
                        </div>
                    </div>
                </section>

                {/* Nuestros Eventos */}
                <section id="nuestros-eventos-section" className="nuestros-eventos-section">
                    <div className="tituloP-container">
                        <h1 className="tituloP">Nuestros eventos</h1>
                    </div>
                    <div className='collage'>
                        <CarouselComponent />
                    </div>
                </section>

                {/* Sección de Contacto */}
                <section id="contacto-section" className="contacto-section">
                    <div className="tituloP-container">
                        <h1 className="tituloP">Contacta con nosotros</h1>
                    </div>
                    <div className="form-container-padre">
                        <Contacto />
                    </div>
                </section>

            </div>

            {/* Botón de Scroll */}
            <ScrollToTop />
        </div >
    );
};

export default Inicio;